import React from 'react';
import PropTypes from 'prop-types';
import { styled, keyframes } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { OPACITY_13 } from 'constants/opacity';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';

export const StyledBorder = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${calculateRgbaWithAlpha(
    theme.palette.sectionNav.link.main,
    OPACITY_13
  )}`
}));

export const StyledDinerName = styled(Typography)(({ theme }) => ({
  padding: '1rem',
  paddingRight: '0rem',
  margin: '0 8px',
  color: theme.palette.sectionNav.link.main,
  fontFamily: theme.typography.fontFamily,
  fontWeight: '450'
}));

export const StyledDinerAction = styled(Typography)(({ theme }) => ({
  marginRight: '8px',
  fontSize: '12px',
  color: theme.palette.mediumSoy,
  fontFamily: theme.typography.fontFamily,
  fontWeight: '450'
}));

export const StyledNoItemsAddedYet = styled(Typography)(({ theme }) => ({
  marginTop: '8px',
  marginBottom: '8px',
  marginLeft: '32px',
  fontSize: '14px',
  color: theme.palette.mediumSoy,
  fontFamily: theme.typography.fontFamily,
  fontWeight: '450'
}));

export const StyledAccountCircleIcon = styled(AccountCircleIcon)(
  ({ theme }) => ({
    width: '28px',
    height: '28px',
    fill: theme.palette.soy
  })
);

export const StyledAbsoluteContainer = ({ children = null }) => (
  <Box
    sx={{
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      left: '-20px',
      width: '400px'
    }}
  >
    {children}
  </Box>
);

StyledAbsoluteContainer.propTypes = {
  children: PropTypes.node
};

export const StyledCheckCircleIcon = styled(CheckCircleIcon)(({ theme }) => ({
  width: '28px',
  height: '28px',
  fill: theme.palette.soy
}));

export const StyledDeleteOutlineOutlinedIcon = styled(DeleteIcon)(() => ({
  width: '20px'
}));

export const DinerInfoContainer = ({ children = null }) => (
  <Box position="relative" height="24px">
    <StyledAbsoluteContainer>{children}</StyledAbsoluteContainer>
  </Box>
);

DinerInfoContainer.propTypes = {
  children: PropTypes.node
};

const dotFlashing = keyframes`
  0% {
    background-color: #babcc1;
  }
  50%, 100% {
    background-color: #e5e5e6;
  }
`;

export const DotFlashing = styled('div')(({ theme }) => ({
  marginLeft: '11px',
  position: 'relative',
  width: '5px',
  height: '5px',
  borderRadius: '2px',
  backgroundColor: '#9880ff',
  color: '#9880ff',
  animation: `${
    theme ? theme.dotFlashing || dotFlashing : dotFlashing
  } 1s infinite linear alternate`,
  animationDelay: '0.5s',
  '&::before, &::after': {
    content: '""',
    display: 'inline-block',
    position: 'absolute',
    top: 0
  },
  '&::before': {
    left: '-8px',
    width: '5px',
    height: '5px',
    borderRadius: '2px',
    backgroundColor: '#babcc1',
    color: '#babcc1',
    animation: `${
      theme ? theme.dotFlashing || dotFlashing : dotFlashing
    } 1s infinite alternate`,
    animationDelay: '0s'
  },
  '&::after': {
    left: '8px',
    width: '5px',
    height: '5px',
    borderRadius: '2px',
    backgroundColor: '#babcc1',
    color: '#babcc1',
    animation: `${
      theme ? theme.dotFlashing || dotFlashing : dotFlashing
    } 1s infinite alternate`,
    animationDelay: '1s'
  }
}));
